module.exports = __webpack_public_path__ + "img/message-square.cda06ca7.svg";